export const getProperty = (ref, property) => ref
    ? Number.parseInt(window.getComputedStyle(ref).getPropertyValue(property), 10)
    : 0;
//# sourceMappingURL=getProperty.js.map